import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HelpModal } from '../../../models';
import {
  LabelRoleSize,
  LabelRoleType,
  TextAlignType
} from '../../../types/common.types';

@Component({
  selector: 'idp-action-label',
  templateUrl: './action-label.component.html',
  styleUrls: ['./action-label.component.scss']
})
export class ActionLabelComponent {
  @Input() text = '';
  @Input() role: LabelRoleType = 'title';
  @Input() icon = false;
  @Input() iconAlign: TextAlignType = 'baseline';
  @Input() size: LabelRoleSize = '';
  @Input() labelId = '';
  @Input() emphasis: 'dark' | 'light' | '' = '';
  @Input() errorState = false;
  @Input() topLabelSrOnly = false; // Will be passed as TRUE from component doesnt needs topLabelText to make label as sr-only for AX
  @Output() clicked: EventEmitter<boolean> = new EventEmitter();
  @Output() iconClicked: EventEmitter<boolean> = new EventEmitter();
  @Input() name = '';
  @Input() displayFlex = false;
  @Input() displayInlineFlex = false;
  @Input() classList = '';
  @Input() helpIcon = false;
  @Input() transformCapitalize = false;
  @Input() helpModal: HelpModal = {
    icon: false,
    title: '',
    content: '',
    type: ''
  };

  notify() {
    if (this.icon) {
      this.clicked.emit(true);
    }
  }

  openModal() {
    if (this.icon) {
      this.iconClicked.emit(true);
    }
  }
}
